import * as React from 'react';
import Box from '../../../parts/Box';
import { IThresholdSettingsData, IThresholdSettingsFunctions } from "../props/IThresholdSettingsProps";


import { Container, Col, Button, Row,  Form, Label, Card, CardTitle, CardBody } from 'reactstrap';
import HelpTooltip from '../../../commons/HelpTooltip';

interface IThresholdSettings {
    singlePoint?: boolean,
}


type IProps =  IThresholdSettingsData & IThresholdSettingsFunctions &
            { history: any };

export default class ThresholdSettings extends React.Component< IProps> {

    infoRef = React.createRef<HTMLFormElement>();
/*---------------------------------------------------------------------------------------------------------------------------------- */
    render() {

        return  <div>
                    <Box title = "FORCE-FIELD SETTINGS">
                    <Form>
                            <Container>

                                <Row>
                                    <label>
                                        <input type="checkbox"
                                            checked={this.props.limitForceFields}
                                            onChange={evt => this.props.changeLimitForceFields(evt.target.checked)}/>
                                            &nbsp;Limit the usage of force-field methods to improve calculation time.
                                    </label>
                                </Row>

                                <Row >
                
                                    <Col>          
                                    <Card>
                                        <CardBody>
                                        <CardTitle tag="h5">
                                            Evolution-based approach
                                        </CardTitle> 
                                        <Row>       
                                        <Col>
                                        <Label htmlFor="minIdentityFieldSP" style = {{color: "#09A0A8", paddingLeft: "4px"}} >
                                            FoldX threshold:
                                                    <HelpTooltip>
                                                    Cut-off used by FoldX in the evolution-based approach. 
                                                    Mutations with predicted ddG higher than this threshold will be discarded.
                                                    </HelpTooltip> 
                                                </Label>
                                        </Col>                    
                                        <form id="ll-input-info" ref={this.infoRef}>
                                            <div className="form-group">
                                                
                                                <input type="text" className="form-control" id="min_identity"
                                                    style = {{width: "75px" , height: "30px"}}
                                                    value={this.props.evolutionFoldXThreshold}
                                                    onChange={evt => this.props.changeEvolutionFoldXThreshold(evt.target.value)}
                                                    required
                                                />
                                            </div>
                                        </form>
                                        </Row>      

                                    
                                        </CardBody>
                                    </Card>
                                                
                                           
                                    </Col>
                                     


                                    <Col>
                                    <Card>
                                        <CardBody>
                                        <CardTitle tag="h5">
                                            Energy-based approach
                                        </CardTitle>         
                                        <Row>       
                                        <Col>
                                                <Label htmlFor="maxNumSeqField" style = {{color: "#09A0A8"}} >
                                                    FoldX threshold:
                                                    <HelpTooltip>
                                                    Cut-off used by FoldX in the energy-based approach. 
                                                    Mutations with predicted ddG higher than this 
                                                    threshold will be omitted from further calculation.
                                                    </HelpTooltip>
                                                </Label>
                                        </Col>                    
                                        <form id = "ll-input-info" ref={this.infoRef}>
                                            <div className = "form-group">                                               
                                                <input type="text" className="form-control" id="blast_e_text" name = "grp1"
                                                    style = {{width: "75px" , height: "30px"}} 
                                                    value={this.props.energyFoldXThreshold}
                                                    onChange={evt => this.props.changeEnergyFoldXThreshold(evt.target.value)}
                                                    required
                                                />
                                            </div>
                                        </form> 
                                        </Row>      

                                         <Row>
                                            <Col>
                                                <Label htmlFor="maxNumSeqField" style = {{color: "#09A0A8"}} >
                                                    Rosetta threshold:
                                                    <HelpTooltip>
                                                    Threshold used by Rosetta in the energy-based approach. 
                                                    Mutations with predicted ddG lower than this value will 
                                                    be accepted as potentially stabilizing mutations.
                                                    </HelpTooltip>
                                                </Label>
                                            </Col>
                                            <form id="ll-input-info" ref={this.infoRef}>
                                            <div className="form-group">
                                                
                                                <input type="text" className="form-control" id="max_num_seq"
                                                    style = {{width: "75px" , height: "30px"}}
                                                    value={this.props.energyRosettaThreshold}
                                                    onChange={evt => this.props.changeEnergyRosettaThreshold(evt.target.value)}
                                                    required
                                                />
                                            </div>
                                            </form>    
                                        </Row>

                                        </CardBody>
                                    </Card>
                                    </Col>

                                    <Col >
                                       <Card>
                                        <CardBody>
                                        <CardTitle tag="h5">
                                            Multipoint mutants
                                        </CardTitle>         
                                        <Row>       
                                        <Col>
                                                <Label htmlFor="maxNumSeqField" style = {{color: "#09A0A8"}} >
                                                    Rosetta threshold:
                                                    <HelpTooltip>
                                                    Cut-off used by Rosetta in the energy-based approach. 
                                                    Mutations with predicted ddG higher than this threshold will be discarded.
                                                    </HelpTooltip>
                                                </Label>
                                        </Col>                    
                                        <form id = "ll-input-info" ref={this.infoRef}>
                                            <div className = "form-group">                                               
                                                <input type="text" className="form-control" id="blast_e_text" name = "grp1"
                                                    style = {{width: "75px" , height: "30px"}} 
                                                    value={this.props.multipointRosettaThreshold}
                                                    onChange={evt => this.props.changeMultipointRosettaThreshold(evt.target.value)}
                                                    required
                                                />
                                            </div>
                                        </form> 
                                        </Row>      
                                        </CardBody>
                                    </Card>
                                    </Col> 
                                </Row>
                            </Container>
                        </Form>
                    </Box>
                    </div>
}}
